"use client"

import { ReactNode } from "react"
import { ThemeProvider } from "@mui/material"

import { Box, isWeb, setUtmCookie } from "@bullseye/components"
import { useSearchParams } from "@bullseye/navigation"

import copy from "../constants/copy"
import MuiTheme from "../styles/MuiTheme"
import AsFeaturedIn from "./Landing/Heros/AsFeaturedIn"
import BlogPreview from "./Landing/Heros/BlogPreview"
import EmptyCalendar from "./Landing/Heros/EmptyCalendar"
import HankMember from "./Landing/Heros/HankMember"
import HeroSignUp from "./Landing/Heros/Hero"
import PotentialFriends from "./Landing/Heros/PotentialFriends"
import SafetyFriendship from "./Landing/Heros/SafetyFriendship"
import UserTestimonials from "./Landing/Heros/UserTestimonials"
import VideoHero from "./Landing/Heros/VideoHero"

type Props = {
  heroImage?: string
  title?: ReactNode
  subtitle?: ReactNode
}

export function HomePage({ heroImage, title, subtitle }: Props) {
  const searchParams = useSearchParams()
  if (isWeb()) {
    setUtmCookie(searchParams)
  }

  return (
    <ThemeProvider theme={MuiTheme}>
      <Box className="flex">
        <HeroSignUp heroImage={heroImage} title={title} subtitle={subtitle} />
        <HankMember />
        <PotentialFriends />
        <EmptyCalendar />
        <SafetyFriendship />
        <UserTestimonials />
        <AsFeaturedIn />
        <VideoHero />
        <BlogPreview copy={copy.home.blogPreview} />
        <Box className="bg-primary-50">
          <Box className="flex flex-row items-center justify-center bg-primary-50 px-4 py-8 md:px-10">
            <Box className="flex w-full max-w-[1200px] flex-row items-center justify-center">
              <div className="klaviyo-form-XQxSY9"></div>
            </Box>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  )
}
